import {
    type Section,
    type ElementId,
    type Step,
    type Flow,
    isConcreteStep,
    type NestedElement,
    type Element,
} from './types.no-deps'
import { stepsElements, walkElements, walkSteps, walkStepsOfStep } from './generators.no-deps'
import { map, toArray, filter } from '../../lib/functional/generator.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { field } from '../../lib/functional/object.no-deps'
import { flatten } from 'lodash'
import { uniq } from '../../lib/functional/array.no-deps'

export function getElementToStepLookup(section: Section) {
    const lookup = new Map<ElementId, Step>()

    for (const step of walkSteps()(section)) {
        for (const element of stepsElements(step)) {
            lookup.set(element.id, step)
        }
    }

    return lookup
}

export function getStepGuideIds(flow: Flow) {
    return pipe(flow, walkSteps(), filter(isConcreteStep), map(field('guides')), toArray, flatten, uniq)
}

export function removeNonConcreteSteps(flow: Flow) {
    flow.steps = flow.steps.filter(isConcreteStep)

    for (const element of walkElements()(flow)) {
        if (!(element.type === 'loop' || element.type === 'section')) {
            continue
        }

        element.steps = element.steps.filter(isConcreteStep)
    }

    return flow
}

export function filterStepElements(step: Step, pred: (element: Element | NestedElement) => boolean) {
    for (const nestedStep of walkStepsOfStep()(step)) {
        if (!isConcreteStep(nestedStep)) {
            continue
        }

        nestedStep.elements = nestedStep.elements.filter(pred)
    }

    return step
}
